/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface MailboxUpdate {
  display_name?: string | null;
  default_signature_id?: string | null;
  unsubscribe_message_html?: string | null;
}
